import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, PersoneTipo } from '../../models/-index';

@Injectable()
export class PersoneTipoService extends CrudGenericsService<PersoneTipo, number> {
  // private base:string;;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/PersoneTipo`);
    //  this.base = `${env.apiUrl}/api/PersoneTipo/`;
  }
}
